import { Form, Tab, TextArea } from 'semantic-ui-react';
import React from 'react';

type Context = {
  whyRecommendation: string;
  focusAreas: string;
  timeframe?: string;
  dataCollection?: string;
  effortRequires?: string[];
};

type TeamRecContextFieldsTabProps = {
  context: Context;
  onChange: (updatedValue: Context) => void;
};
export const TeamRecContextFieldsTab = (props: TeamRecContextFieldsTabProps) => {
  const { context, onChange } = props;

  return () => (
    <Tab.Pane attached={false}>
      <Form>
        <Form.Field>
          <label>Why make this recommendation?</label>
          <TextArea
            value={context.whyRecommendation}
            onChange={e =>
              onChange({
                ...context,
                whyRecommendation: e.target.value,
              })
            }
          />
        </Form.Field>
        <Form.Field>
          <label>Focus Areas</label>
          <TextArea
            value={context.focusAreas}
            onChange={e =>
              onChange({
                ...context,
                focusAreas: e.target.value,
              })
            }
          />
        </Form.Field>
        <Form.Field>
          <label>Time Estimate</label>
          <Form.Input
            placeholder="e.g., '3-6 months', 'Ongoing', '2 weeks'"
            value={context.timeframe || ''}
            onChange={e =>
              onChange({
                ...context,
                timeframe: e.target.value,
              })
            }
          />
          <small style={{ color: '#666', marginTop: '4px', display: 'block' }}>
            How long the intervention takes (e.g., "3-6 months", "Ongoing")
          </small>
        </Form.Field>
        <Form.Field>
          <label>Measure</label>
          <Form.Input
            placeholder="What metric/outcome it targets"
            value={context.dataCollection || ''}
            onChange={e =>
              onChange({
                ...context,
                dataCollection: e.target.value,
              })
            }
          />
          <small style={{ color: '#666', marginTop: '4px', display: 'block' }}>
            What metric or outcome this recommendation targets
          </small>
        </Form.Field>
        <Form.Field>
          <label>Intervention Type</label>
          <Form.Input
            placeholder="e.g., 'Policy', 'Cultural', 'Process', 'Structural'"
            value={context.effortRequires?.[0] || ''}
            onChange={e =>
              onChange({
                ...context,
                effortRequires: e.target.value ? [e.target.value] : [],
              })
            }
          />
          <small style={{ color: '#666', marginTop: '4px', display: 'block' }}>
            Category of intervention (e.g., "Policy", "Cultural", "Process")
          </small>
        </Form.Field>
      </Form>
    </Tab.Pane>
  );
};

export default TeamRecContextFieldsTab;
